import React, {useEffect, useRef, useState} from "react";
import {Link} from "react-router-dom";
// Image
import image01 from "../../../../../../images/avatar/1.jpg";
import image02 from "../../../../../../images/avatar/2.jpg";
import image03 from "../../../../../../images/avatar/3.jpg";
import image04 from "../../../../../../images/avatar/4.jpg";
import image05 from "../../../../../../images/avatar/5.jpg";
import image06 from "../../../../../../images/avatar/6.jpg";
import NoProfile from "../../../../../../images/profileImage.png";
import ImageComponent from "../../../../shared/ImageComponent";
import {buildImageUrl} from "../../../../../../utils/imageUrlBuilder";
import StarIcon from "../../../../../../images/icons/starIcon";
import {getDateLocale} from "../../../../../../utils/date";

const AllReviewTable = ({reviews}) => {
  return (
    <div id="All" className="tab-pane">
      <div className="table-responsive fs-14">
        <div id="allreview" className="dataTables_wrapper no-footer">
          <table
            id="example2"
            className="table !bg-[#F1F2F7] !rounded-lg mb-4 dataTablesCard no-hover card-table fs-14 dataTable no-footer"
            role="grid"
            aria-describedby="example2_info"
          >
            <thead>
              <tr role="row">
                <th
                  style={{width: "250px"}}
                  className="sorting !text-[#19295C] !text-sm !p-4 !font-normal"
                  tabindex="0"
                  aria-controls="example5"
                  rowspan="1"
                  colspan="1"
                  aria-label="Customer: activate to sort column ascending"
                >
                  Client
                </th>
                <th
                  className="d-none d-sm-inline-block sorting !text-[#19295C] !text-sm !p-4 !font-normal"
                  tabindex="0"
                  aria-controls="example5"
                  rowspan="1"
                  colspan="1"
                  aria-label="Event NAME: activate to sort column ascending"
                >
                  Titre de l'intervention
                </th>
                <th
                  className="sorting !text-[#19295C] !text-sm !p-4 !font-normal"
                  tabindex="0"
                  aria-controls="example5"
                  rowspan="1"
                  colspan="1"
                  aria-label="Stars Review: activate to sort column ascending"
                >
                  Avis
                </th>
              </tr>
            </thead>

            <tbody>
              {reviews.map((review) => (
                <tr role="row" className="odd">
                  <td className="!p-4">
                    <div className="media align-items-center ">
                      <div className="relative xl:mr-3 ">
                        {!!review?.createdBy?.avgRating && (
                          <div className="bg-[#FFC107] w-1/2 hidden xl:flex justify-center gap-[2px] items-center leading-none px-[3px] py-[2px] text-white text-[9px] absolute bottom-0 rounded-md left-[50%] -translate-x-[50%] ">
                            {Number(review?.createdBy?.avgRating).toFixed(2)}
                            <StarIcon className="fill-white stroke-none w-3 h-3 " />
                          </div>
                        )}
                        <ImageComponent
                          className="img-fluid !rounded-full d-none d-xl-inline-block"
                          width="70"
                          src={buildImageUrl(review?.createdBy?.imageUri)}
                          alt="DexignZone"
                          fallback={
                            <img
                              className="img-fluid !rounded-full  d-none d-xl-inline-block"
                              width="70"
                              src={NoProfile}
                              alt="DexignZone"
                            />
                          }
                        />
                      </div>
                      <div className="media-body">
                        <h4 className="font-w600 mb-1  wspace-no">
                          <Link to="" className="text-[#19295C] !text-[15px] ">
                            {review?.createdBy?.lastname +
                              " " +
                              review?.createdBy?.firstname}
                          </Link>
                        </h4>
                        <span>
                          {new Date(review?.createdAt)
                            .toLocaleDateString(getDateLocale(), {
                              day: "numeric",
                              month: "short",
                              year: "numeric",
                            })
                            .replace(".", " ")}
                        </span>
                      </div>
                    </div>
                  </td>
                  <td className="d-none d-sm-table-cell !p-4 ">
                    {review?.Intervention?.Offer_Proposal?.Offer?.title ?? "--"}
                  </td>
                  <td className="!align-top !p-4 ">
                    <div className="flex flex-col justify-start items-start ">
                      <div className="flex gap-3 justify-start items-center">
                        <span className="star-review d-inline-block mb-2 fs-16 wspace-no">
                          {Array.from({length: 5}, (_, index) => (
                            <i
                              key={index}
                              className={`fa fa-star fs-16 ${
                                index < Math.round(review?.rating)
                                  ? "text-orange"
                                  : "text-gray"
                              }`}
                            ></i>
                          ))}
                        </span>
                      </div>
                      <p className="mb-0 d-none d-xl-inline-block">
                        {review?.comment}
                      </p>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
            <div className="dataTables_info">
              Showing {activePag.current * sort + 1} to{" "}
              {data.length > (activePag.current + 1) * sort
                ? (activePag.current + 1) * sort
                : data.length}{" "}
              of {data.length} entries
            </div>
            <div
              className="dataTables_paginate paging_simple_numbers"
              id="example2_paginate"
            >
              <Link
                className="paginate_button previous disabled"
                to="/reviews"
                onClick={() =>
                  activePag.current > 0 && onClick(activePag.current - 1)
                }
              >
                Previous
              </Link>
              <span>
                {paggination.map((number, i) => (
                  <Link
                    key={i}
                    to="/reviews"
                    className={`paginate_button  ${
                      activePag.current === i ? "current" : ""
                    } `}
                    onClick={() => onClick(i)}
                  >
                    {number}
                  </Link>
                ))}
              </span>

              <Link
                className="paginate_button next"
                to="/reviews"
                onClick={() =>
                  activePag.current + 1 < paggination.length &&
                  onClick(activePag.current + 1)
                }
              >
                Next
              </Link>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default AllReviewTable;
